import { fetchUserAttributes } from "aws-amplify/auth";
export const getUserPermissions = async () => {
  const userAttributes: { email: string; permissions: object } = {
    email: "",
    permissions: {},
  };
  const currentUser = await fetchUserAttributes();
  Object.entries(currentUser).forEach((value) => {
    if (value[0] === "email") {
      if (value[1] as string) {
        userAttributes.email = value[1] as string;
      }
    }
    if (value[0] === "custom:permissions") {
      if (value[1]) {
        userAttributes.permissions = JSON.parse(value[1] as string);
      }
    }
  });
  return userAttributes;
};
